import React from 'react';
import PropTypes from 'prop-types';
import useWindowSize from '../hooks/useWindowSize';
import imgDesktop from '../assets/photos/popup-navidad-large.jpg';
import imgMobile from '../assets/photos/popup-navidad-medim.jpg';
import { ModalBase } from './commons/Modal';

const ModalChristmas = ({ isOpen, onClose }) => {
  const { width: screenWidth } = useWindowSize();
  const isMobile = screenWidth < 768;

  return (
    <ModalBase
      isOpen={isOpen}
      onRequestClose={onClose}
      width={isMobile ? '90%' : '900px'}
      maxWidth="900px">
      <div className="modal-christmas">
        <img
          src={isMobile ? imgMobile : imgDesktop}
          alt="Navidad | Santa"
          className="modal-christmas__image" />

        <div className="modal-christmas__body">
          <p className="modal-christmas__text">
            <strong>¡Listo!</strong>
            Has asegurado tu tranquilidad para el próximo año.
            <br />
            Santa está en camino y, tras validar tu pago, nos pondremos en contacto contigo.
          </p>

          <button
            type="button"
            onClick={onClose}
            className="modal-christmas__button">
            Cerrar
          </button>
        </div>
      </div>
    </ModalBase>
  );
};

ModalChristmas.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModalChristmas;
